/* import __COLOCATED_TEMPLATE__ from './client-section.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();